export class DynamicQueryEvent {
  constructor(public readonly event, public readonly data) {}
}

export const DynamicQueryEventTypes = {
  DONE: 'done',
  INSERTED: 'inserted',
  UPDATED: 'updated',
  DELETED: 'deleted'
};

export class DynamicQueryEventFactory {
  public static EVENT_TYPES = DynamicQueryEventTypes;

  public static createEvent(event, data) {
    return new DynamicQueryEvent(event, data);
  }
}
